











































































































import { Component, Vue, Emit, Prop } from "vue-property-decorator";

import { Dialog, Popup } from "vant";
import { englishjanala } from "../../protos";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */

@Component({
  components: {},
})
export default class NewQuestion extends Vue {
  show: boolean = false;
  errors: any = [];

  questinItems = ["MCQ_ANYONE_CHOICE", "MCQ_MULTIPLE_CHOICE", "TRANSLATE_REARRANGE"];
  answer = "";
  question = englishjanala.question.Question.length;
  new_question: any = {
    questionTitle: "",
    imageUrl: "",
    questionType: "",
    answerOptions: ["", "", "", ""],
    answerId: -1,
    answerIndices: [0, 0, 0, 0],
    reorderAnswerList: [],
  };
  @Emit("NewQuestion")
  NewQuestion() {
    return this.new_question;
  }

  checkRequired() {
    if (this.new_question.questionType == "TRANSLATE_REARRANGE") {
      if (this.new_question.questionTitle && this.new_question.reorderAnswerList) {
        return true;
      } else {
        this.errors = [];
        if (!this.new_question.questionTitle) {
          this.errors.push("question required.");
        }
        if (!this.new_question.reorderAnswerList) {
          this.errors.push("answer required.");
        }
      }
    } else {
      this.errors = [];
      if (!this.new_question.questionTitle) {
        this.errors.push("question required.");
      }
      // check anyone choice
      else if (
        this.new_question.questionType == this.questinItems[0] &&
        this.new_question.answerId == -1
      ) {
        this.errors.push("optionss required.");
      } else {
        const answerId = this.new_question.answerIndices.indexOf(true) + 1;
        if (answerId == 0 && this.new_question.questionType != this.questinItems[0]) {
          this.errors.push("options required.");
        }
      }
    }
    if (this.errors.length > 0) return false;
    else return true;
  }
  SaveChapter() {
    if (this.checkRequired()) {
      this.NewQuestion();
      this.show = false;
    }
  }
  showPopup() {
    this.show = true;
  }
}
